import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AutoCompleteDictionary } from "components/AutoCompleteDictionary/AutoCompleteDictionary";
import { Button } from "components/Button/Button";
import { ModalForm } from "components/ModalForm/ModalForm";
import { useEffect, useState } from "react";
import { ICON_TYPE } from "utils/constants";
import { ENDPOINTS } from "utils/endpoints";
import { PersonGrid } from "./PersonGrid";
import "./style.scss";
interface PersonPropsType {
  required?: boolean;
  value?: string;
  label?: string;
  mode?: string;
  WithSearch?: boolean;
  name: string;
  DescriptionKey?: string;
  resetForm?: boolean;
  returnObj?: boolean;
  Change?: (e) => void;
  setPerson?: any;
  valueString?:any
}

export const Person = ({
  DescriptionKey,
  value,
  mode,
  name,
  required,
  label = "person",
  resetForm,
  WithSearch = true,
  returnObj = false,
  Change,
  setPerson,
  valueString
}: PersonPropsType) => {
  const [showSerch, setShowSerch] = useState(false);
  const [defaultValue, setDefaultValue] = useState(value);
  const [seachedValue, setSearchedValue] = useState("");

  const personIdCallBack = (e) => {
    setShowSerch(false);
    setDefaultValue(e)
  };


  useEffect(() => {
    setDefaultValue(value);
  }, [value]);

  return (
    <>
       {showSerch && (
        <ModalForm
          modalHeight={49}
          mode={mode}
          onHide={() => {
            setShowSerch(false);
          }}
          show={showSerch}
          title={"person"}
        >
          <PersonGrid
            personIdCallBack={personIdCallBack}
            serch={seachedValue}
          />
        </ModalForm>
      )}
      <div className={`text-box  ${(WithSearch && mode != "view")&&" d-flex" }`} >

        <AutoCompleteDictionary
          returnObj={returnObj}
          required={required}
          onChange={(e) => {
            console.log({e});
            if(returnObj) {setPerson&&setPerson(e)}
            else{
              setPerson&&  setPerson(e.Id)
            }
          }}
          searchedHandleFun={(e) => {
            setSearchedValue(e);
          }}
          DescriptionKey={DescriptionKey}
          className={(WithSearch && mode != "view")?"text-box col-11" : "text-box"}
          name={name}
          label={label}
          baseUrl={undefined}
          url={ENDPOINTS.BaseInformation.person.dictionary}
          secendUrl={ ENDPOINTS.BaseInformation.person.dictionaryId}
          value={defaultValue}
          mode={mode}
          
        />
      {WithSearch && mode != "view" && (
          <Button
            Icon={true}
            value={
              <button
                type="button"
                onClick={(e) => {
                  setShowSerch(true);
                }}
                className="checkButton mt-4 d-flex align-items-center justify-content-center"
              >
                {" "}
                <FontAwesomeIcon
                  icon={[ICON_TYPE, "search"]}
                  style={{ transform: "rotateY(180deg)", fontSize: "15px" }}
                  size="1x"
                />
              </button>
            }
            btnType="primary"
            onClick={(e) => {}}
          />
        )}
      </div>
    </>
  );
};

